import { render, staticRenderFns } from "./UpdateAvatarDialog.vue?vue&type=template&id=51072652&scoped=true"
import script from "./UpdateAvatarDialog.vue?vue&type=script&lang=js"
export * from "./UpdateAvatarDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateAvatarDialog.vue?vue&type=style&index=0&id=51072652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51072652",
  null
  
)

export default component.exports